import type { Msg, Session } from '@halo/chat-sdk-react';
import { MsgPayloadType } from '@halo/chat-sdk-react';
import {
  MsgTextPreviewContent,
  MsgStickerPreviewContent,
  MsgImagePreviewContent,
  MsgFilePreviewContent,
  MsgLuckyBoxPreviewContent,
  MsgTransferPreviewContent,
} from '.';

export interface MsgsReplyItemProps {
  session: Session | undefined;
  message: Msg | undefined;
}

export const MsgsReplyItem = memo(function MsgsReplyItem({
  session,
  message,
}: MsgsReplyItemProps) {
  const children = useMemo(() => {
    if (!session || !message) return null;
    switch (message?.payload_type) {
      case MsgPayloadType.TEXT:
        return <MsgTextPreviewContent message={message} />;
      case MsgPayloadType.STICKER:
        return <MsgStickerPreviewContent />;
      case MsgPayloadType.IMAGE:
        return <MsgImagePreviewContent />;
      case MsgPayloadType.FILE:
        return <MsgFilePreviewContent message={message} />;
      case MsgPayloadType.LUCKY_BOX:
        return <MsgLuckyBoxPreviewContent />;
      case MsgPayloadType.TRANSFER:
        return <MsgTransferPreviewContent message={message} session={session} />;
    }
  }, [session, message]);

  return children;
});
